import { render, staticRenderFns } from "./contestant-layout.vue?vue&type=template&id=affa1e0e&scoped=true"
import script from "./contestant-layout.vue?vue&type=script&lang=js"
export * from "./contestant-layout.vue?vue&type=script&lang=js"
import style0 from "./contestant-layout.vue?vue&type=style&index=0&id=affa1e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affa1e0e",
  null
  
)

export default component.exports